import { RootState } from 'store';
import { TIsLoading } from 'common/types/common';
import {
  checkIsDoneStatus,
  checkIsLoadStatus,
  checkIsErrorStatus,
} from 'common/utils/loadingStatus';

import { STATE } from '../types/state';

export const selectorAllStationsStatusLoading = (
  state: RootState,
): TIsLoading => {
  const {
    allStations: { isLoading },
  } = state[STATE];
  return isLoading;
};

export const selectAllStationsIsDone = (state: RootState): boolean =>
  checkIsDoneStatus(selectorAllStationsStatusLoading(state));

export const isAllStationsLoading = (state: RootState): boolean =>
  checkIsLoadStatus(selectorAllStationsStatusLoading(state));

export const isAllStationsError = (state: RootState): boolean =>
  checkIsErrorStatus(selectorAllStationsStatusLoading(state));
